<template>
    <span>
      <rp-select
        v-if="isDuet() == false"
        v-model="iolManufacturer"
        :placeholder="'IOL Manufacturer'"
        @input="onManufacturerChanged">
        <option v-for="man in manufacturers" :key="man" :value="man">
          {{man}}
        </option>
      </rp-select>

      <rp-select
        v-if="iolManufacturer !== ''"      
        v-model="iolModel"
        :placeholder="modelPlaceholder"
        @input="touchModel">
        <option v-for="iol in filteredIolModels" :key="iol.id" :value="iol.id">
          {{iol.model}}
        </option>
      </rp-select>

      <rp-select
        v-if="isPowerActive"
        v-model="iolPower"
        :placeholder="powerPlaceholder"
        @input="childDropdownInput(powerTouch)">
        <option v-for="power in powers" :key="power" :value="power">
          {{power}}
        </option>
      </rp-select>

      <rp-select
        v-if="isCylActive"
        v-model="iolCyl"
        :placeholder="cylPlaceholder"
        @input="childDropdownInput(cylTouch)">
        <option v-for="power in cylPowers" :key="power" :value="power">
          {{power}}
        </option>
      </rp-select>
    </span>
</template>

<script>
import Select from '../../../components/ui/inputs/StyledSelect'

export default {

  components: {
    'rp-select': Select
  },
  
  props: {
    'value': Object,
    'iolModels': Array,
    'powers': Array,
    'cylPowers': Array,
    'modelPlaceholder': String,
    'powerPlaceholder': String,
    'powerTouch': String,
    'cylPlaceholder': String,
    'cylTouch': String,
    'resourceObjectModel': String,
    'resourceObjectPower': String,
    'resourceObjectCyl': String,
    'resourceObjectEye': String
  },

  data() {
    return {
      manufacturers: [],
      filteredIolModels: [],
      currentManufacturer: ''
    }
  },

  mounted() {
    this.initManufacturers()
  },

  computed: {
    iolManufacturer: {
      get() {
        return this.currentManufacturer
      },

      set(value) {
        this.currentManufacturer = value
      }
    },
    iolModel: {
      get() {
        return this.value[this.resourceObjectModel]
      },

      set(value) {
        this.$set(this.value, this.resourceObjectModel, value)
      }
    },
    iolPower: {
      get() {
        return this.value[this.resourceObjectPower]
      },

      set(value) {
        this.$set(this.value, this.resourceObjectPower, value)
      }
    },
    iolCyl: {
      get() {
        return this.value[this.resourceObjectCyl]
      },

      set(value) {
        this.$set(this.value, this.resourceObjectCyl, value)
      }
    },

    isCylActive() {
      const isCylActive = !!(this.value[this.resourceObjectModel] && this.value[this.resourceObjectEye] && this.cylPowers.length)
      return isCylActive
    },

    isPowerActive() {
      const isPowerActive = !!(this.value[this.resourceObjectModel] && this.value[this.resourceObjectEye])
      return isPowerActive
    }
  },

  watch: { 
    iolModels: function() {
      this.initManufacturers()
    }
  },

  methods: {
    touchModel() {
      this.$emit('model')
    },

    childDropdownInput(value) {
      this.$emit('touch', value)
    },

    initManufacturers() {
      this.manufacturers = this.getManufacturers()

      if (this.iolModel) {
        this.iolManufacturer = this.iolModels.filter((x) => x.id == this.iolModel)[0].manufacturer
      }
      else if (this.isDuet() || (this.manufacturers.length == 1 && this.manufacturers[0] == 'Rayner')) {
        this.iolManufacturer = 'Rayner'
      }

      this.filteredIolModels = []
      this.iolModels.forEach((x) => {if (x.manufacturer === this.iolManufacturer) {this.filteredIolModels.push(x)}})
    },

    getManufacturers() {
      let mans = []
      this.iolModels.forEach((x) => {if (!mans.includes(x.manufacturer)) {mans.push(x.manufacturer)}})
      return mans
    },

    onManufacturerChanged(value) {
      this.filteredIolModels = []
      this.iolModels.forEach((x) => {if (x.manufacturer === value) {this.filteredIolModels.push(x)}})
      this.iolModel = ''
      this.iolPower = ''
      this.iolCyl = ''
      this.touchModel()
    },
  
    isDuet() {
      return this.modelPlaceholder.startsWith('DUET')
    }
  }

}
</script>

<style lang="sass" scoped>
@import '../../../styles/base/variables'
@import '../../../styles/helpers/mixins'

.item
  display: flex
  .required
    fill: $color-error
    display: inline
    margin: 8px 10px
</style>


// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/forms/IolModelSelector.vue